import React from 'react';

export const Row = props => {
    return (
        <div className={`row text-center ${props.wrapperClassName}`}>
            <div
                className={`col-xs-23 ${props.className} background-color-${props.color}`}>
                {props.children}
            </div>
        </div>
    );
};
